import { render } from "./LibAwards.vue?vue&type=template&id=05499e83&scoped=true"
import script from "./LibAwards.vue?vue&type=script&lang=js"
export * from "./LibAwards.vue?vue&type=script&lang=js"

import "./LibAwards.vue?vue&type=style&index=0&id=05499e83&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05499e83"]])

export default __exports__